import css from 'styled-jsx/css';

const styles = css.global`#perguntas .disclaimer {
    margin-top: 16px;
  }
  
  #perguntas .disclaimer-text {
    color: #999;
    font-family: "SantanderMicroText";
    font-size: 14px;
    font-style: normal;
    font-weight: 200;
    line-height: 22px;
  }
  
  #perguntas .perguntas-contain {
    margin-top: 48px;
    margin-bottom: 80px;
  }
  
  #perguntas .img-perguntas {
    width: 100%;
    height: 240px;
    object-fit: cover;
    object-position: top;
    border-radius: 4px;
  }
  
  #perguntas.perguntas-pesados .img-perguntas {
    object-position: center;
  }
  
  #perguntas .group-perguntas {
    margin-top: 24px;
  }
  
  #perguntas .group-perguntas .title-perguntas {
    color: #444;
    font-family: "SantanderHeadline";
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: 36px;
    margin-bottom: 24px;
    max-width: 270px;
  }
  
  #perguntas .custom-accordion .acc-header .acc-title {
    color: #444;
    font-size: 18px;
    padding-right: 15px;
  }
  
  #perguntas .custom-accordion .acc-header {
    padding: 0 0 16px;
  }
  
  #perguntas .custom-accordion.mb-space {
    margin-bottom: 40px;
  }
  
  #perguntas .custom-accordion.opened .acc-header {
    background-color: #ffffff;
  }
  
  #perguntas .custom-accordion .acc-body.default p {
    color: #444;
    font-size: 18px;
    line-height: 1.56;
  }

  #perguntas .custom-accordion .acc-body.default p a {
    font-family: "SantanderText";
    font-style: normal;
    font-weight: 400;
    color: #C00;
  }

  #perguntas .custom-accordion .acc-body.default p a:hover {
    text-decoration: underline;
  }
  
  #perguntas a.btn-outline-red {
    color: #C00;
    font-family: "SantanderText";
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px;
    margin-top: -16px;
    display: block;
  }
  
  #perguntas a.btn-outline-red:hover {
    transition: all 350ms linear;
    text-decoration: underline;
  }
  
  #perguntas .link-faq {
    color: #C00;
    font-family: "SantanderText";
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px;
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: none;
    text-decoration-thickness: auto;
    text-underline-offset: auto;
    text-underline-position: from-font;
  }
  
  /* @media(min-width: 530px) {
    #perguntas .img-perguntas {
      object-fit: contain;
    }
  } */
  
  @media (min-width: 992px) {
    #perguntas .disclaimer {
      margin-top: 8px;
    }
  
    #perguntas .custom-accordion .acc-header .acc-title {
      font-size: 20px;
    }
  
    #perguntas .perguntas-contain {
      display: flex;
      justify-content: space-between;
      width: 100%;
      /* margin-top: 112px; */
      margin-bottom: 24px;
    }
  
    #perguntas .img-perguntas {
      height: 540px;
      width: 420px;
    }
  
    #perguntas .group-perguntas {
      margin-top: 0;
      margin-left: 48px;
      width: 100%;
    }
  
    #perguntas .group-perguntas .title-perguntas {
      text-align: left;
      line-height: 36px;
      margin-bottom: 40px;
    }
  
    #perguntas a.btn-outline-red {
      margin: 0;
      text-decoration-line: underline;
      text-decoration-style: solid;
      text-decoration-skip-ink: none;
      text-decoration-thickness: auto;
      text-underline-offset: auto;
      text-underline-position: from-font;
    }
  
    #perguntas .custom-accordion .acc-header {
      padding: 0 16px 16px 0;
      min-height: auto;
    }
  
    #perguntas .custom-accordion .acc-body.default p {
      max-width: 690px;
    }
  
    #perguntas .group-perguntas .title-perguntas {
      max-width: unset;
    }
  }`;

export default styles;